import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MainPipe } from '../../shared/pipes/pipes.module';
import { CustomerReviewRoutingModule } from './customer-review-routing.module';
import { CustomerReviewComponent } from './customer-review.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LoadingModule } from '../../shared/loading/loading.module';
import { RatingSelectorModule } from './rating-selector/rating-selector.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { CustomerReviewResolve } from './customer-review.resolve';

@NgModule({
  declarations: [CustomerReviewComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MainPipe,
    CustomerReviewRoutingModule,
    MatProgressBarModule,
    LoadingModule,
    RatingSelectorModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  providers: [CustomerReviewResolve],
})
export class CustomerReviewModule {}
